import { useNavigate, useParams } from "react-router-dom";
import CardHeader from "../../../antd/components/CardHeader";
import { useContext, useEffect, useState } from "react";
import './styles.css';
import { ISelectProps } from "../../../Interfaces/ISelectProps";
import { AllEligibleType } from "../../../Utils/AllEligibleType";
import useLoading from "../../../Hooks/useLoading";
import Loader from "../../../Components/Shared/Loader";
import { IResponseProps } from "../../../Interfaces/IResponseProps";
import { toast } from "react-toastify";
import { CompanyContext } from "../../../Contexts/CompanyContext";
import { ProjectModel } from "../../../Models/ProjectModel";
import { EditProjectAPI, GetProjectAPI } from "../../../API/ProjectsAPI";
import { AuthContext } from "../../../Contexts/AuthContext";
import { AllStatus } from "../../../Utils/AllContratTypes";
import ModalConfirmHistoricComponent from "../../../Components/ProjectInformations/ModalConfirmHistoricComponent";
import useModal from "../../../Hooks/useModal";
import useCan from "../../../Hooks/useCan";
import { Button, Collapse, DatePicker, Form, Input, Select } from "antd";
import TextArea from "antd/es/input/TextArea";
import 'dayjs/locale/pt-br';
import locale from 'antd/es/date-picker/locale/pt_BR';
import dayjs from "dayjs";

const EditProject = () => {
    const { projectId } = useParams();
    const { showModal, toggleShowModal } = useModal();
    const { company } = useContext(CompanyContext);
    const { userEmail } = useContext(AuthContext);
    const { loading, toggleLoading } = useLoading();
    const [budget, setBudget] = useState<string>("0");
    const [equipmentValue, setEquipmentValue] = useState<string>("0");
    const [contractTypeText, setContractTypeText] = useState<string>("");
    const [inProgress, setInProgress] = useState<boolean>(false);
    const [changing, setChanging] = useState<string>("");
    const [project, setProject] = useState<ProjectModel>({} as ProjectModel);
    const [continueResp, setContinueResp] = useState<boolean>(false);
    const navigate = useNavigate();
    const canView = useCan({ rolesCan: ["Manager", "Consultant", "Administrator"] })
    const [form] = Form.useForm();


    // const setZeroForAll = () => {
    //     let result = parseFloat(RhValue) + parseFloat(infraValue) + parseFloat(invoicesValue) + parseFloat(equipmentValue);

    //     if (result != parseFloat(budget)) {
    //         setRhValue("0");
    //         setEquipmentValue("0");
    //         setInfraValue("0");
    //         setInvoicesValue("0");
    //     }
    // }

    const setAllInformations = (project: ProjectModel) => {
        setProject(project);
        if (project.budget != 0 && parseFloat(budget) == 0) {
            setBudget(project.budget.toString());
        }
    }

    const getProjectInfo = async (id: string) => {
        try {
            toggleLoading(true);

            await GetProjectAPI(id).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    const project: ProjectModel = resp.data;
                    if (project) {
                        setAllInformations(project);
                    }
                }
            }).finally(() => {
                toggleLoading(false);
            });
        } catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }
    }

    const Submit = async () => {
        try {
            toggleLoading(true);

            const data = form.getFieldsValue();
            let projectName = data.projectName ?? "";
            let activities = data.activities ?? "";
            let budget = data.budget ?? "0"
            let startDate = data.startDate ? data.startDate.format('DD/MM/YYYY') : null;
            let endDate = data.endDate ? data.endDate.format('DD/MM/YYYY') : null;
            let eligibleText = data.eligibleText;
            let objective = data.objective ?? "";
            let contractCET = !!data.contractCET;
            let expectedExpenses = data.expectedExpenses ?? "";
            let valuesApplied = !!data.valuesApplied;
            let rhValue = data.rhvalue ?? "0"
            let infraValue = data.infrastructureValue ?? "0"
            let invoicesValue = data.invoiceValue ?? "0"
            let othersValue = data.othersValue ?? null
            await EditProjectAPI(
                projectId ?? "",
                userEmail,
                projectName,
                activities,
                startDate,
                endDate,
                budget.replace(",", "."),
                rhValue.replace(",", "."),
                equipmentValue.replace(",", "."),
                invoicesValue.replace(",", "."),
                infraValue.replace(",", "."),
                eligibleText,
                company.id,
                contractTypeText,
                inProgress,
                objective,
                contractCET,
                expectedExpenses,
                valuesApplied,
                othersValue
            ).then((resp: IResponseProps) => {
                if (resp.statusCode === 200) {
                    toast.success(`Projeto ${projectName} editado com sucesso!`);
                    navigate(`/projectInformation/${company.id}`);
                }
            }).finally(() => {
                toggleLoading(false);
            });
        }
        catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }
    }

    useEffect(() => {
        if (projectId != "") {
            getProjectInfo(projectId ?? "");
        }
    }, [projectId]);

    useEffect(() => {
        if (changing != "") {
            toggleShowModal();
        }
    }, [changing]);

    useEffect(() => {
        form.setFieldsValue({
            budget: form.getFieldValue("budget") || "0.00",
        });
    }, [form]);


    useEffect(() => {
        if (project) {
            form.setFieldsValue({
                projectName: project.name,
                budget: project.budget?.toString() || "", // Converte para string para evitar erros
                startDate: project.startDate ? dayjs(project.startDate) : null,
                endDate: project.endDate ? dayjs(project.endDate) : null,
                eligibleText: String(project.eligibleType),
                objective: project.objective,
                activities: project.activities,
                expectedExpenses: project.expectedExpenses,
                contractCET: project.contractCET,
                valuesApplied: project.valuesApplied,
                rhvalue: project.rhValue?.toString() || "",
                infrastructureValue: project.infraValue?.toString() || "",
                invoiceValue: project.invoiceValue?.toString() || "",
                othersValue: project.others?.toString() || null
            });
        }
    }, [project]); // Atualiza sempre que o `project` mudar

    return (
        <div className='card ml-2 mr-2'>
            {loading && <Loader />}
            <CardHeader
                pageName={"Editar Projeto"}
                hasPageBefore={true}
                linkPageBefore={`/projectInformation/${company.id}`}
                pageBeforeName={"Informações de Projetos"}
            />
            <ModalConfirmHistoricComponent
                setResponse={setContinueResp}
                show={showModal}
                toggleShow={toggleShowModal}
                changing={changing}
            />
            <div className='card-body mt-2 ps-4 pe-4'>
                <Form form={form} layout="vertical">
                    <div className='d-flex align-items-center row'>
                        <div className="col-md-6">
                            <Form.Item className="w-100 me-3"
                                name="projectName"

                                label="Nome do Projeto:">
                                <Input className='form-control mt-2'
                                    placeholder=" Nome do Projeto.."

                                />
                            </Form.Item>
                        </div>
                        <div className="col-md-3">
                            <Form.Item name="startDate" label=" Data de Previsão de Inicio" className=" w-100 mt-1">
                                <DatePicker locale={locale} style={{ width: '100%', height: '40px' }} format={"DD/MM/YYYY"} />
                            </Form.Item>
                        </div>
                        <div className="col-md-3">
                            <Form.Item name="endDate" label="Data de Previsão de Termino" className=" w-100 mt-1">
                                <DatePicker
                                    locale={locale}
                                    style={{ width: '100%', height: '40px' }}
                                    format={"DD/MM/YYYY"}
                                />
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <Form.Item name="objective"
                                label="Objetivo"
                                required
                                className="mt-2 mb-2">
                                <TextArea rows={5}
                                    className="form-control mt-2"
                                />
                            </Form.Item>
                        </div>
                        <div className="col">
                            <Form.Item name="activities"
                                label="Atividades Associadas ao Projeto:"
                                required
                                className="mt-2 mb-2">
                                <TextArea rows={5}
                                    className="form-control mt-2"
                                />
                            </Form.Item>
                        </div>
                    </div>
                    <div className='d-flex align-items-center row'>
                        <div className=" col-md-6 mb-3">
                            <label>Tem contrato com ICTs?</label>
                            <Form.Item
                                name="contractCET"
                                rules={[{ required: true, message: 'Por favor, selecione uma opção!' }]}>
                                <Select
                                    style={{ width: ' 100%', height: '40px' }}
                                    options={[{ value: false, label: 'Não' },
                                    { value: true, label: "Sim" }
                                    ]}
                                />
                            </Form.Item>
                        </div>
                        <div className="col-md-6 mb-3">
                            <label>Elegível para o financiamento?</label>
                            <Form.Item name="eligibleText">
                                <Select
                                    disabled={!canView}
                                    style={{ width: ' 100%', height: '40px' }}
                                    options={[{ value: "0", label: 'Elegivel' },
                                    { value: "1", label: "Não Elegivel" },
                                    { value: "2", label: "Talvez" },
                                    { value: "3", label: "Pendente" }
                                    ]}
                                />
                            </Form.Item>

                        </div>
                    </div>
                    <div className="mb-4 ">
                        <Collapse
                            items={[{
                                key: '1',
                                label: 'Orçamento Estimado do Projeto:',
                                forceRender: true,
                                children: (
                                    <div id="collapse" className='p-3' >
                                        <div className='row '>
                                            <div className="col-12 mx-0">
                                                <Form.Item label="Gastos esperados" name="expectedExpenses">
                                                    <Input
                                                        style={{ height: "40px" }}
                                                        className="form-control"
                                                        placeholder="Gastos esperados..."
                                                        onChange={(e) => {
                                                            setBudget(e.target.value);
                                                            form.setFieldsValue({ expectedExpenses: e.target.value }); // Atualiza o Form.Item
                                                        }}
                                                    // onBlur={setZeroForAll}
                                                    />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className=' row'>
                                            <div className=" col-md-6">
                                                <label>Há valores já Aplicados ao projeto?</label>
                                                <Form.Item
                                                    name="valuesApplied">
                                                    <Select
                                                        style={{ width: ' 100%', height: '40px' }}
                                                        options={[
                                                            { value: false, label: 'Não' },
                                                            { value: true, label: 'Sim' }
                                                        ]}
                                                    />
                                                </Form.Item>
                                            </div>
                                            <div className=" col-md-6 mb-3">
                                                <label>Orçamento estimado do projeto</label>
                                                <Form.Item className=' w-100'
                                                    name="budget">
                                                    <Input style={{ width: "100%", height: '40px' }}
                                                        id="input-example"
                                                        name="buget"
                                                        className='form-control'
                                                        placeholder="R$ 0,00"

                                                    />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }]}
                        />
                    </div>
                    <div className="mb-4 ">
                        <Collapse
                            items={[{
                                key: '1', label: 'Rubricas por Projeto:', children: <div id="collapse" className='p-1'>

                                    <div className='row p-b-2'>
                                        <div className=" col-md-3">
                                            <label>Recursos Humanos: </label>
                                            <Form.Item
                                                name="rhvalue">
                                                <Input style={{ width: "100%", height: '40px' }}
                                                    id="input-example"
                                                    name="rhvalue"
                                                    className='form-control'
                                                    placeholder="R$ 1000,00"

                                                />
                                            </Form.Item>


                                        </div>

                                        <div className=" col-md-3">
                                            <label>Infraestrutura</label>
                                            <Form.Item className=' w-100'
                                                name="infrastructureValue">
                                                <Input style={{ width: "100%", height: '40px' }}
                                                    id="input-example"
                                                    name="infrastructureValue"
                                                    className='form-control'
                                                    placeholder="R$ 1000,00"

                                                />
                                            </Form.Item>

                                        </div>

                                        <div className=" col-md-3">
                                            <label>Serviços de Terceiro</label>
                                            <Form.Item className=' w-100'
                                                name="invoiceValue">
                                                <Input style={{ width: "100%", height: '40px' }}
                                                    id="input-example"
                                                    name="invoiceValue"
                                                    className='form-control'
                                                    placeholder="R$ 1000,00"

                                                />
                                            </Form.Item>

                                        </div>

                                        <div className=" col-md-3">
                                            <label>Outros</label>
                                            <Form.Item className=' w-100'
                                                name="othersValue">
                                                <Input style={{ width: "100%", height: '40px' }}
                                                    id="input-example"
                                                    name="othersValue"
                                                    className='form-control'
                                                    placeholder="R$ 1000,00"

                                                />
                                            </Form.Item>

                                        </div>

                                    </div>

                                </div>
                            }]}
                        />
                    </div>
                    <Button
                        style={{ textAlign: 'center', height: '40px' }}
                        type="primary"
                        onClick={Submit}
                        className="btn btn-primary w-100 mb-3 mt-4">
                        Salvar Projeto
                    </Button>
                </Form>
            </div>
        </div>
    )
}

export default EditProject;